import { Inject, Injectable } from 'angular-ts-decorators';

export interface IPfmUrlHelperService {
  filters: string[];
  pageNumber: number;
  searchQuery: string;
  sorter: string;
}

@Injectable('pfmUrlHelper')
export class PfmUrlHelperService implements IPfmUrlHelperService {
  public static $inject: ReadonlyArray<string> = ['$location'];

  constructor(@Inject('$location') private $location: ng.ILocationService) { }

  public get filters(): string[] {
    return (this.$location.search().pff || '').split('-').filter((f: string): boolean => f !== '');
  }

  public set filters(filters: string[]) {
    // tslint:disable-next-line:no-null-keyword
    this.$location.search('pff', Array.isArray(filters) && filters.length > 0 ? filters.join('-') : null);
  }

  public get pageNumber(): number {
    let locationPageNumber: number = Number(this.$location.search().pfp);
    if (isNaN(locationPageNumber)) {
      locationPageNumber = 1;
    }

    return locationPageNumber;
  }

  public set pageNumber(pageNumber: number) {
    // tslint:disable-next-line:no-null-keyword
    this.$location.search('pfp', pageNumber || null);
  }

  public get searchQuery(): string {
    return this.$location.search().pfq || '';
  }

  public set searchQuery(searchQuery: string) {
    // tslint:disable-next-line:no-null-keyword
    this.$location.search('pfq', searchQuery || null);
  }

  public get sorter(): string {
    return this.$location.search().pfs || '';
  }

  public set sorter(sorter: string) {
    // tslint:disable-next-line:no-null-keyword
    this.$location.search('pfs', sorter || null);
  }
}
